import { getChartLabel } from "./chartLabel";
import {
  ResponsiveContainer,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  BarChart,
  Bar,
  LabelList,
  Cell,
} from "recharts";
import { useState } from "react";
import { Form } from "react-bootstrap";
import CustomLegend from "./CustomLegend";
import CustomTooltipCat from "./CustomTooltipCat";
import CustomTooltip from "./CustomTooltip";

//kpi-3
// const Category = ({ data, filters, selectedState }) => {
//   const [showTable, setShowTable] = useState(false);
//   if (!Array.isArray(data) || data.length === 0) {
//     return (
//       <div
//         style={{
//           textAlign: "center",
//           padding: "40px",
//           backgroundColor: "#fff",
//           border: "1px solid #ddd",
//           borderRadius: "8px",
//           marginTop: "20px",
//         }}
//       >
//         <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
//       </div>
//     );
//   }

//   const severityOrder = {
//     "Very Low": 1,
//     Low: 2,
//     Moderate: 3,
//     High: 4,
//     "Very High": 5,
//   };

//   const catData = data.map((item) => {
//     return {
//       place: item.Place,
//       category: severityOrder[item.average_category],
//     };
//   });
//   const tableData = data.map((item) => {
//     return {
//       place: item.Place,
//       category: item.average_category,
//     };
//   });
//   const inverseSeverity = Object.entries(severityOrder).reduce(
//     (acc, [k, v]) => {
//       acc[v] = k;
//       return acc;
//     },
//     {}
//   );

//   return (
//     <div style={{ width: "100%", position: "relative" }}>
//       <div className="card hptCard mt-4 border-0">
//         <div class="card-header brBtomlr">
//           <div class="headnumText justify-content-between">
//             <div class="cardTitle">
//               <h5>Category</h5>
//             </div>

//             <div class="cardDropDown">
//               <span style={{ marginRight: "10px", fontWeight: 500 }}>
//                 {showTable ? "Chart View" : "Table View"}
//               </span>
//               <Form>
//                 <Form.Check
//                   type="switch"
//                   id="chart-table-toggle"
//                   onChange={() => setShowTable((prev) => !prev)}
//                   checked={showTable}
//                 />
//               </Form>
//             </div>
//           </div>
//         </div>
//       </div>
//       {showTable ? (
//         // Table View
//         <div className="card hptCard mt-4 border-0">
//           <div className="table-responsive">
//             <table className="table  table-bordered ">
//               <thead className="thead-light">
//                 <tr>
//                   <th>Place</th>
//                   <th>Category</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, idx) => (
//                   <tr key={idx}>
//                     <td style={{ fontWeight: "bold" }}>{item.place}</td>
//                     <td>{item.category}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       ) : (
//         <div className="card hptCard mt-4 border-0">
//           <ResponsiveContainer width="100%" height={500}>
//             <BarChart
//               width={500}
//               height={500}
//               data={catData}
//               margin={{
//                 top: 20,
//                 right: 30,
//                 left: 40,
//                 bottom: 130,
//               }}
//             >
//               <XAxis
//                 dataKey="place"
//                 angle={-90}
//                 textAnchor="end"
//                 interval={0}
//                 label={{
//                   value: "",
//                   position: "insideBottom",
//                   offset: -110,
//                   color: "#ca8282ff",
//                   fontWeight: "bold",
//                 }}
//               />
//               <YAxis
//                 dataKey="category"
//                 tickFormatter={(val) => inverseSeverity[val]}
//                 domain={[1, 5]}
//                 label={{
//                   value: "",
//                   angle: -90,
//                   position: "outside",
//                   offset: -100,
//                 }}
//               />
//               <Tooltip content={<CustomTooltipCat />} />
//               <Legend verticalAlign="top" content={<CustomLegend />} />
//               <Bar dataKey="category" fill="#00a084">
//                 <LabelList
//                   dataKey="category"
//                   position="top"
//                   content={({ x, y, width, value }) => {
//                     if (!value) return null;
//                     return (
//                       <text
//                         x={x + width / 2} // horizontal center
//                         y={y} // vertical center
//                         // white text (change if needed)
//                         fontSize={12}
//                         fontWeight="bold"
//                         textAnchor="middle"
//                         dominantBaseline="middle"
//                       >
//                         {inverseSeverity[value]}
//                       </text>
//                     );
//                   }}
//                 />
//               </Bar>
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       )}
//     </div>
//   );
// };
// export default Category;

const Category = ({ data, filters, selectedState }) => {
  const [showTable, setShowTable] = useState(false);
  console.log("cat", data);
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }

  // Severity mapping
  const severityOrder = {
    "Very Low": 1,
    Low: 2,
    Moderate: 3,
    High: 4,
  };
  const severityColors = {
    1: "#00a084", // Very Low - green
    2: "#608ce6ff", // Low - lighter green
    3: "#ffc40c", // Moderate - yellow
    4: "#dd1e47", // Very High - red
  };

  const toTitleCase = (str) => {
    if (!str || typeof str !== "string") return ""; // 👈 safeguard
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Detect if it's state-level or district-level by checking response shape
  const isStateLevel = data[0].hasOwnProperty("Low");

  let catData = [];
  let tableData = [];

  if (isStateLevel) {
    // State-level → show counts for each severity
    catData = data.map((item) => ({
      place: item.State,
      VeryLow: item.VeryLow,
      Low: item.Low,
      Moderate: item.Moderate,
      High: item.High,
    }));

    tableData = data.map((item) => ({
      place: item.State,
      VeryLow: item.VeryLow,
      Low: item.Low,
      Moderate: item.Moderate,
      High: item.High,
    }));
  } else {
    // District-level → single average_category
    catData = data.map((item) => ({
      place: item.District,
      category: severityOrder[toTitleCase(item.Category) || ""], //item.Category.toLowerCase()
    }));

    tableData = data.map((item) => ({
      place: item.District,
      category: toTitleCase(item.Category) || "",
    }));
  }
  const inverseSeverity = Object.entries(severityOrder).reduce(
    (acc, [k, v]) => {
      acc[v] = k;
      return acc;
    },
    {},
  );

  const chunkArray = (array, chunkCount) => {
    const result = [];
    const chunkSize = Math.ceil(array.length / chunkCount);

    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  };

  const getChartCount = (length) => {
    if (length < 15) return 1;
    if (length >= 9 && length <= 18) return 2;
    if (length <= 45) return 3;
    return Math.ceil(length / 20);
  };

  // 👉 prepare chart data
  const chartCount = getChartCount(catData.length);
  const chunkedData = chunkArray(catData, chartCount);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <div class="cardTitle">
              <h5>Category {getChartLabel(filters, selectedState)}</h5>
            </div>

            <div class="cardDropDown gap-3">
              <div style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </div>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>
      {showTable ? (
        // ---------- Table View ----------
        <div className="card hptCard mt-4 border-0">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th className="fw-bold">Place</th>
                  {isStateLevel ? (
                    <>
                      <th className="text-center fw-bold ">Very Low</th>
                      <th className="text-center fw-bold"> Low</th>
                      <th className="text-center fw-bold">Moderate</th>
                      <th className="text-center fw-bold">High</th>
                    </>
                  ) : (
                    <th className="text-center fw-bold">Category</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, idx) => (
                  <tr key={idx}>
                    <td className="fw-bold">{item.place}</td>
                    {isStateLevel ? (
                      <>
                        <td>{item.VeryLow}</td>
                        <td>{item.Low}</td>
                        <td>{item.Moderate}</td>
                        <td>{item.High}</td>
                      </>
                    ) : (
                      <td>{item.category}</td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        // ---------- Chart View ----------
        <div>
          {chunkedData.map((chunk, idx) => (
            <div key={idx} className="card hptCard mt-4 border-0">
              <ResponsiveContainer width="100%" height={600}>
                {isStateLevel ? (
                  // Bar chart with multiple bars for state-level
                  <BarChart
                    width={500}
                    height={400}
                    data={chunk}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 40,
                      bottom: 180,
                    }}
                  >
                    <XAxis
                      dataKey="place"
                      angle={-90}
                      textAnchor="end"
                      interval={0}
                      label={{
                        value: "",
                        position: "insideBottom",
                        offset: -110,
                        color: "#ca8282ff",
                        fontWeight: "bold",
                      }}
                    />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                      verticalAlign="top"
                      content={
                        <CustomLegend
                          order={["VeryLow", "Low", "Moderate", "High"]}
                        />
                      }
                    />
                    <Bar dataKey="VeryLow" fill="#00a084">
                      <LabelList dataKey="VeryLow" position="top" />
                    </Bar>
                    <Bar dataKey="Low" fill="#608ce6ff">
                      <LabelList dataKey="Low" position="top" />
                    </Bar>
                    <Bar dataKey="Moderate" fill="#ffc40c">
                      <LabelList dataKey="Moderate" position="top" />
                    </Bar>
                    <Bar dataKey="High" fill="#dd1e47">
                      <LabelList dataKey="High" position="top" />
                    </Bar>
                  </BarChart>
                ) : (
                  // Bar chart with single category for district-level

                  <BarChart
                    data={chunk}
                    width={500}
                    height={300}
                    margin={{
                      top: 60,
                      right: 30,
                      left: 40,
                      bottom: 180,
                    }}
                  >
                    <XAxis
                      dataKey="place"
                      angle={-90}
                      textAnchor="end"
                      interval={0}
                    />
                    <YAxis
                      dataKey="category"
                      tickFormatter={(val) =>
                        Object.keys(severityOrder).find(
                          (key) => severityOrder[key] === val,
                        )
                      }
                      domain={[0, 5]}
                      ticks={[1, 2, 3, 4]}
                    />
                    <Tooltip content={<CustomTooltipCat />} />
                    {/* <Legend
                  verticalAlign="top"
                  content={
                    <CustomLegend
                      order={["VeryLow", "Low", "Moderate", "High"]}
                    />
                  }
                /> */}

                    <Bar dataKey="category">
                      {chunk.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={severityColors[entry.category] || "#8884d8"}
                        />
                      ))}
                      <LabelList
                        dataKey="category"
                        position="top"
                        content={({ x, y, width, value }) => {
                          if (!value) return null;
                          return (
                            <text
                              x={x + width / 2} // horizontal center
                              y={y - 5} // vertical center
                              // white text (change if needed)

                              fontSize={12}
                              fontWeight="bold"
                              textAnchor="middle"
                              dominantBaseline="middle"
                            >
                              {toTitleCase(inverseSeverity[value])}
                            </text>
                          );
                        }}
                      />
                    </Bar>
                  </BarChart>
                )}
              </ResponsiveContainer>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Category;
